// src/utils/branding.ts

/**
 * Returns the correct logo url based on theme mode, falling back as needed.
 */
export const getLogo = (branding: any, mode: 'light' | 'dark', isCollapsed: boolean): string => {
    if (isCollapsed && branding?.collapsed_logo_url) {
        return branding.collapsed_logo_url;
    }

    if (mode === 'dark' && branding?.logo_dark_url) {
        return branding.logo_dark_url;
    }

    if (mode === 'light' && branding?.logo_light_url) {
        return branding.logo_light_url;
    }



    if (branding?.logo_light_url) {
        return branding.logo_light_url;
    }

    if (branding?.theme_config?.logo_url) {
        return branding.theme_config.logo_url;
    }


    return null;
};

/**
 * Legacy support for getLogoLight
 */
export const getLogoLight = (branding: any): string => {
    return getLogo(branding, 'light', false);
};

/**
 * Legacy support for getLogoDark
 */
export const getLogoDark = (branding: any): string => {
    return getLogo(branding, 'dark', false);
};

/**
 * Legacy support for getCollapsedLogo
 */
export const getCollapsedLogo = (branding: any): string => {
    return getLogo(branding, 'light', true);
};

/**
 * List of supported font families across the platform.
 */
export const FONT_FAMILIES = [
    'Inter',
    'Roboto',
    'Open Sans',
    'Lato',
    'Montserrat',
    'Poppins',
    'Outfit',
    'Helvetica',
    'Georgia'
];
